var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"type":"video/mp4","autoplay":"","muted":"","loop":"","playsinline":"","src":_vm.src},domProps:{"muted":true},on:{"canplay":_vm.loaded}})}
var staticRenderFns = []

export { render, staticRenderFns }